import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'truthy',
  standalone: false,
})
export class TruthyPipe implements PipeTransform {
  public transform(value: unknown): boolean {
    if (typeof value === 'string') {
      const normalizedValue = value.trim().toLowerCase()
      if (['false', 'no', 'n', '0'].includes(normalizedValue)) return false
      if (['true', 'yes', 'y', '1'].includes(normalizedValue)) return true
    }

    return !!value
  }
}
